<div class="modal fade" id="agreementModal" tabindex="-1" role="dialog" aria-labelledby="agreementModal"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg app-leg-dlg" role="document">
        <div class="modal-content">
            <div class="modal-body">
                <div class="app-leg-dialog-subtitle title"> Quick Heads up before you begin the application process! We
                    want to make sure you get it right the first time, so here’s a list of some of the info required to
                    complete the application: </div>
                <ol>
                    <li>Business information:
                        <ul>
                            <li>Legal Business Name (If a Sole Proprietor, provide your business DBA Name if any)</li>
                            <li>State Of Incorporation (If a Sole Proprietor, State you are conducting business) </li>
                            <li>Age of business</li>
                        </ul>
                    </li>
                    <li>Owner/Guarantor Info:
                        <ul>
                            <li>Social Security Number</li>
                            <li>Ownership percentage</li>
                            <li>Driver’s License Number of each owner and/or Guarantor</li>
                        </ul>
                    </li>
                    <li>Address where the equipment will be installed/delivered if different from the main office or
                        headquarters</li>
                </ol> <span>To receive the best possible offer please also provide the following:</span>
                <ul>
                    <li>EIN/TIN of your business (If a Sole Proprietor, your Social Security # is your EIN)</li>
                </ul>
                <div *ngIf="staticLink">
                    <div class="select-sales-person-title">
                        Are you working with a Sales Rep? Please select from list below
                    </div>

                    <select [formControl]="salesPeopleForm.controls.select" class="form-control"
                        id="salesPeopleSelection" name="salesPeopleSelection" (change)="salesPersonChanged()">
                        <option *ngFor="let salesPerson of salesPeople" [ngValue]="salesPerson.id">
                            {{salesPerson.name}}
                        </option>
                    </select>
                </div>
                <div class="row">
                    <div class="col-12">
                        <button type="submit" data-dismiss="modal"
                            class="btn btn-primary btn-lg col-md-12 col-xs-12 round-button font-mont-regular">
                            CLICK here to begin
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>